module.exports = __webpack_public_path__ + "img/mgm.9e4d1a10.png";